import { createThemeContract } from "@vanilla-extract/css";

export const primitiveTokens = {
  colors: {
    gradients: {
      light: {
        1: "radial-gradient(at 24% 24%, hsla(243, 100%, 96%, 1), hsla(307, 100%, 93%, 1))",
        2: "radial-gradient(at 24% 24%, hsla(243, 100%, 96%, 1), hsla(205, 100%, 93%, 1))",
        3: "radial-gradient(at 24% 24%, hsla(243, 100%, 96%, 1), hsla(127, 100%, 93%, 1))",
        4: "radial-gradient(at 24% 24%, hsla(243, 100%, 96%, 1), hsla(26, 100%, 93%, 1))",
        5: "radial-gradient(186.46% 141.42% at 0% 0%, hsla(243, 99%, 88%, 1) 23.56%, hsla(26, 100%, 82%, 1) 100%)"
      },
      dark: {
        1: "radial-gradient(at 24% 24%, hsla(245, 19%, 24%, 1), hsla(276, 24%, 23%, 1))",
        2: "radial-gradient(at 24% 24%, hsla(245, 19%, 24%, 1), hsla(225, 23%, 24%, 1))",
        3: "radial-gradient(at 24% 24%, hsla(245, 19%, 24%, 1), hsla(188, 14%, 21%, 1))",
        4: "radial-gradient(at 24% 24%, hsla(245, 19%, 24%, 1), hsla(312, 9%, 22%, 1))",
        5: "linear-gradient(0deg, hsla(247, 28%, 12%, 0.84) 0%, hsla(247, 28%, 12%, 0.84) 100%), radial-gradient(186.46% 141.42% at 0% 0%, hsla(243, 99%, 88%, 1) 23.56%,  hsla(26, 100%, 82%, 1) 100%)"
      },
      sliderTrack:
        "linear-gradient(270deg, hsla(205, 100%, 35%, 1) 0%, hsla(205, 100%, 83%, 1) 25%, hsla(253, 100%, 92%, 1) 50%, hsla(347, 77%, 75%, 1) 75%, hsla(347, 77%, 31%, 1) 100%)"
    },
    /**
     * Graph colors
     * Used for lines, bars, and other graphical elements in charts.
     */
    graph: {
      purple: {
        400: "hsla(253, 44%, 56%, 1)",
        700: "hsla(253, 35%, 26%, 1)"
      },
      blue: {
        300: "hsla(162, 39%, 63%, 1)",
        400: "hsla(205, 100%, 68%, 1)",
        500: "hsla(205, 100%, 55%, 1)",
        700: "hsla(205, 100%, 35%, 1)"
      },
      green: {
        400: "hsla(133, 67%, 63%, 1)",
        500: "hsla(155, 94%, 75%, 1)",
        700: "hsla(133, 66%, 25%, 1)"
      },
      yellow: {
        400: "hsla(35, 84%, 62%, 1)",
        500: "hsla(14, 94%, 65%, 1)",
        700: "hsla(35, 85%, 32%, 1)"
      },
      red: {
        400: "hsla(347, 77%, 64%, 1)",
        700: "hsla(347, 77%, 31%, 1)",
        500: "hsla(347, 77%, 51%, 1)"
      },
      neutral: {
        400: "hsla(253, 6%, 74%, 1)",
        700: "hsla(253, 2%, 35%, 1)"
      }
    },
    neutral: {
      50: "hsla(253, 50%, 98%, 1)",
      100: "hsla(253, 32%, 94%, 1)",
      200: "hsla(253, 19%, 90%, 1)",
      300: "hsla(253, 10%, 82%, 1)",
      400: "hsla(253, 6%, 74%, 1)",
      500: "hsla(253, 3%, 63%, 1)",
      600: "hsla(253, 2%, 47%, 1)",
      700: "hsla(253, 2%, 35%, 1)",
      800: "hsla(253, 2%, 24%, 1)",
      900: "hsla(253, 2%, 16%, 1)"
    },
    purple: {
      50: "hsla(253, 100%, 97%, 1)",
      100: "hsla(253, 100%, 92%, 1)",
      200: "hsla(253, 100%, 82%, 1)",
      300: "hsla(253, 83%, 70%, 1)",
      400: "hsla(253, 44%, 56%, 1)",
      500: "hsla(253, 35%, 41%, 1)",
      600: "hsla(253, 35%, 33%, 1)",
      700: "hsla(253, 35%, 26%, 1)",
      800: "hsla(253, 35%, 19%, 1)",
      900: "hsla(253, 35%, 11%, 1)"
    },
    red: {
      50: "hsla(347, 77%, 96%, 1)",
      100: "hsla(347, 78%, 93%, 1)",
      200: "hsla(347, 77%, 84%, 1)",
      300: "hsla(347, 77%, 75%, 1)",
      400: "hsla(347, 77%, 64%, 1)",
      500: "hsla(347, 77%, 51%, 1)",
      600: "hsla(347, 77%, 41%, 1)",
      700: "hsla(347, 77%, 31%, 1)",
      800: "hsla(347, 78%, 21%, 1)",
      900: "hsla(346, 79%, 11%, 1)"
    },
    green: {
      50: "hsla(134, 65%, 96%, 1)",
      100: "hsla(133, 66%, 91%, 1)",
      200: "hsla(133, 66%, 81%, 1)",
      300: "hsla(133, 66%, 73%, 1)",
      400: "hsla(133, 67%, 63%, 1)",
      500: "hsla(133, 66%, 51%, 1)",
      600: "hsla(133, 66%, 41%, 1)",
      700: "hsla(133, 66%, 25%, 1)",
      800: "hsla(133, 66%, 15%, 1)",
      900: "hsla(133, 66%, 6%, 1)"
    },
    yellow: {
      50: "hsla(35, 85%, 96%, 1)",
      100: "hsla(35, 85%, 92%, 1)",
      200: "hsla(35, 85%, 82%, 1)",
      300: "hsla(35, 85%, 72%, 1)",
      400: "hsla(35, 84%, 62%, 1)",
      500: "hsla(35, 85%, 52%, 1)",
      600: "hsla(35, 85%, 42%, 1)",
      700: "hsla(35, 85%, 32%, 1)",
      800: "hsla(35, 85%, 22%, 1)",
      900: "hsla(35, 85%, 10%, 1)"
    },

    shadow: {
      focusRing: "0px 0px 0px 2px hsla(255, 81%, 70%, 0.36)",
      popover: "0px 4px 16px 0px hsla(253, 35%, 33%, 0.16)",
      sheet: "0px 0px 16px 0px hsla(253, 44%, 52%, 0.16)"
    },
    white: {
      100: "hsla(0, 0%, 100%, 0)",
      1000: "hsla(0, 0%, 100%, 1)"
    },
    blue: {
      50: "hsla(204, 100%, 99%, 1)",
      100: "hsla(204, 100%, 98%, 1)",
      200: "hsla(205, 100%, 93%, 1)",
      300: "hsla(205, 100%, 83%, 1)",
      400: "hsla(205, 100%, 68%, 1)",
      500: "hsla(205, 100%, 55%, 1)",
      600: "hsla(205, 100%, 45%, 1)",
      700: "hsla(205, 100%, 35%, 1)",
      800: "hsla(205, 100%, 22%, 1)",
      900: "hsla(205, 100%, 10%, 1)"
    }
  },
  radii: {
    xs: "4px",
    sm: "8px",
    md: "12px",
    lg: "16px",
    xl: "20px"
  },
  sizing: {
    "0x": "0px",
    "0.25x": "1px",
    "1x": "4px",
    "2x": "8px",
    "2.5x": "10px",
    "3x": "12px",
    "3.5x": "14px",
    "4x": "16px",
    "5x": "20px",
    "6x": "24px",
    "7x": "28px",
    "8x": "32px",
    "9x": "36px",
    "10x": "40px",
    "12x": "48px",
    "13x": "52px",
    "14x": "56px",
    "16x": "64px",
    "24x": "96px",
    "36x": "144px"
  },
  borderWidth: {
    default: "1px"
  },
  strokes: {
    md: "1.5px"
  },
  type: {
    xs: "12px",
    sm: "14px",
    md: "16px",
    lg: "18px",
    xl: "20px",
    xxl: "28px"
  },
  animations: {
    elementFade: "opacity 0.2s ease, visibility 0.2s ease"
  },
  transitionDuration: {
    default: "0.25s"
  },
  heatmap: {
    colorRange: {
      1: "rgb(5, 49, 94)",
      2: "rgb(26, 82, 145)",
      3: "rgb(172, 210, 233)",
      4: "rgb(252, 235, 223)",
      5: "rgb(229, 131, 78)",
      6: "rgb(180, 28, 56)",
      7: "rgb(102, 0, 20)"
    }
  }
} as const;

export const semanticThemeTokens = createThemeContract({
  backgroundGradient: {
    1: null,
    2: null,
    3: null,
    4: null
  },
  button: {
    primary: {
      active: { backgroundColor: null },
      default: { backgroundColor: null },
      disabled: { backgroundColor: null, textColor: null },
      focus: { backgroundColor: null },
      hover: { backgroundColor: null },
      textColor: null
    },
    secondary: {
      active: { backgroundColor: null },
      default: { backgroundColor: null, borderColor: null },
      disabled: { backgroundColor: null, borderColor: null, textColor: null },
      focus: { backgroundColor: null, boxShadow: null },
      hover: { backgroundColor: null },
      loading: { backgroundColor: null },
      textColor: null
    },
    tertiary: {
      active: { backgroundColor: null },
      disabled: { textColor: null },
      hover: { backgroundColor: null },
      loading: { backgroundColor: null },
      textColor: null
    }
  },
  checkbox: {
    checked: {
      active: { backgroundColor: null, borderColor: null },
      backgroundColor: null,
      borderColor: null,
      checkmarkColor: null,
      disabled: {
        backgroundColor: null,
        borderColor: null,
        checkmarkColor: null,
        labelTextColor: null
      },
      focus: { borderColor: null, boxShadow: null },
      hover: { borderColor: null }
    },
    labelTextColor: null,
    unchecked: {
      active: { backgroundColor: null, borderColor: null },
      backgroundColor: null,
      default: { borderColor: null },
      disabled: {
        backgroundColor: null,
        borderColor: null,
        labelTextColor: null
      },
      focus: { borderColor: null, boxShadow: null },
      hover: { backgroundColor: null, borderColor: null }
    }
  },
  chip: {
    backgroundColor: null,
    borderColor: null,
    closeIconColor: null,
    disabledBackgroundColor: null,
    disabledBorderColor: null,
    disabledCloseIconColor: null,
    disabledTextColor: null,
    hoverBorderColor: null,
    textColor: null
  },
  note: {
    info: {
      backgroundColor: null,
      textColor: null
    },
    warning: {
      backgroundColor: null,
      textColor: null
    },
    error: {
      backgroundColor: null,
      textColor: null
    }
  },
  color: {
    backgroundColor: {
      default: null
    },
    textColor: null
  },
  dataTable: {
    backgroundColor: null,
    colorScheme: null,
    borderColor: null,
    headerBackgroundColor: null,
    primaryColor: null,
    row: {
      colorPalette: {
        1: null,
        2: null,
        3: null,
        4: null,
        5: null,
        6: null,
        7: null,
        8: null,
        9: null,
        10: null
      },
      crossTableRowStyle: { match: null, shift: null },
      backgroundColorOdd: null,
      borderColor: null,
      hover: { backgroundColor: null },
      selected: { backgroundColor: null }
    },
    dropdown: {
      backgroundColor: null
    },
    // Semantic text colors for conditionally-styled cells (e.g. KPIs that turn
    // red/green by sign, status ratings, highlighted identity columns).
    cell: {
      positive: null,
      negative: null,
      warning: null,
      highlight: null
    }
  },
  divider: {
    backgroundColor: null,
    color: null
  },
  drawer: {
    backgroundColor: null
  },
  dropdown: {
    content: { backgroundColor: null, color: null },
    item: {
      default: { backgroundColor: null },
      hover: { backgroundColor: null, color: null }
    },
    trigger: {
      active: { backgroundColor: null, color: null },
      default: { backgroundColor: null, color: null },
      hover: { backgroundColor: null, color: null }
    }
  },
  input: {
    backgroundColor: null,
    cursorColor: null,
    filled: {
      active: { borderColor: null },
      default: { borderColor: null },
      disabled: { backgroundColor: null, borderColor: null, textColor: null },
      hover: { borderColor: null },
      textColor: null
    },
    invalid: { backgroundColor: null, borderColor: null },
    unfilled: {
      active: { borderColor: null },
      default: { borderColor: null },
      disabled: { backgroundColor: null, borderColor: null, textColor: null },
      hover: { borderColor: null },
      textColor: null
    }
  },
  label: {
    color: {
      disabled: null,
      optionalDisabled: null,
      optionalRegular: null,
      regular: null
    }
  },
  loginPage: {
    background: null,
    container: { backgroundColor: null, borderColor: null },
    copyRight: { color: null },
    forgotPassword: { color: null },
    heading: { color: null }
  },
  logo: {
    fill: null
  },
  tile: {
    backgroundColor: null,
    borderColor: null
  },
  navigationMenu: {
    fontSize: null,
    placeholderColor: null,
    selected: { backgroundColor: null, color: null }
  },
  radio: {
    active: { backgroundColor: null, borderColor: null },
    backgroundColor: null,
    borderColor: null,
    checkmark: {
      active: { borderColor: null },
      backgroundColor: null,
      borderColor: null,
      disabled: { backgroundColor: null, borderColor: null },
      hover: { borderColor: null }
    },
    disabled: { backgroundColor: null, borderColor: null },
    focus: { boxShadow: null },
    hover: { borderColor: null },
    label: {
      disabled: { textColor: null },
      invalid: { textColor: null },
      textColor: null
    }
  },
  select: {
    default: {
      backgroundColor: null,
      borderColor: null,
      textColor: null,
      textColorSelected: null
    },
    disabled: {
      backgroundColor: null,
      borderColor: null,
      textColor: null,
      textColorSelected: null
    },
    focus: { backgroundColor: null },
    hover: { backgroundColor: null },
    icon: { color: null, disabledColor: null },
    menuList: {
      backgroundColor: null,
      listItem: {
        hover: { backgroundColor: null },
        selected: { backgroundColor: null },
        textColor: null
      }
    }
  },
  sheet: {
    layer1: { backgroundColor: null },
    layer2: { backgroundColor: null },
    layer3: { backgroundColor: null },
    shadow: null,
    transitionDuration: null
  },
  switch: {
    backgroundColor: {
      default: { toggled: null, untoggled: null },
      disabled: { toggled: null, untoggled: null },
      hover: { toggled: null, untoggled: null }
    },
    label: { textColor: null, textcolorDisabled: null },
    thumb: { backgroundColor: null },
    toggle: { indicatorColor: null, indicatorColorDisabled: null }
  },
  tabs: {
    list: { backgroundColor: null, color: null },
    separator: { backgroundColor: null },
    trigger: {
      backgroundColor: null,
      borderColor: null,
      disabled: {
        backgroundColor: null,
        borderColor: null,
        selected: { backgroundColor: null, textColor: null },
        textColor: null
      },
      focus: { boxShadow: null, outline: null },
      hover: { backgroundColor: null, textColor: null },
      selected: { backgroundColor: null, borderColor: null, textColor: null },
      textColor: null,
      transitionDuration: null,
      transitionProperty: null
    }
  },
  toggleGroup: {
    item: {
      borderColor: null,
      focus: { boxShadow: null, outline: null },
      hover: { backgroundColor: null },
      selected: { backgroundColor: null, borderColor: null, textColor: null }
    }
  },
  themeSwitcher: {
    backgroundColor: null,
    iconColor: null,
    textColor: null,
    thumbColor: null
  },
  transition: null,
  userMenu: {
    iconColor: null
  },
  dialog: {
    overlay: {
      backgroundColor: null
    },
    content: {
      background: null,
      boxShadow: null,
      textColor: null
    },
    title: {
      fontSize: null,
      textColor: null
    },
    description: {
      textColor: null,
      fontSize: null
    },
    iconButton: {
      backgroundColor: null,
      textColor: null
    }
  },
  toast: {
    default: {
      backgroundColor: null,
      borderColor: null,
      titleColor: null,
      descriptionColor: null
    },
    success: {
      backgroundColor: null,
      borderColor: null,
      titleColor: null,
      descriptionColor: null
    },
    warning: {
      backgroundColor: null,
      borderColor: null,
      titleColor: null,
      descriptionColor: null
    },
    error: {
      backgroundColor: null,
      borderColor: null,
      titleColor: null,
      descriptionColor: null
    }
  },
  tabsNav: {
    fontSize: null,
    default: { backgroundColor: null, textColor: null },
    active: { backgroundColor: null, textColor: null },
    hover: { backgroundColor: null, textColor: null }
  },
  sparklineGraph: {
    trend: {
      stroke: null
    },
    seasonality: {
      stroke: null
    },
    styleSeries: {
      color: null,
      fill: null
    },
    rosFwd16: {
      negativeMarker: null
    },
    rebuyOverstock: {
      full: null,
      partial: null
    },
    // A sequential ramp for a curve whose points are ordered stages, not
    // categories: one hue, monotone light -> dark, so position AND shade both
    // say how far along the stage is. Six steps because the order flow has six.
    orderFlow: {
      1: null,
      2: null,
      3: null,
      4: null,
      5: null,
      6: null
    }
  },
  chart: {
    borderColour: null,
    backgroundColor: null,
    textColor: null,
    tooltipBackground: null,
    tooltipTextColor: null,
    foregroundColor: null,
    chromeBackgroundColor: null,
    chromeSubtleTextColor: null,
    crosshairLabelBackgroundColor: null,
    crosshairLabelTextColor: null,
    gridColor: null,
    palette: {
      fill: {
        1: null,
        2: null,
        3: null,
        4: null,
        5: null,
        6: null,
        7: null,
        8: null,
        9: null,
        10: null
      },
      stroke: {
        1: null,
        2: null,
        3: null,
        4: null,
        5: null,
        6: null,
        7: null,
        8: null,
        9: null,
        10: null
      }
    }
  },
  barChart: {
    salesFill: null,
    purchaseFill: null,
    sellthroughFill: null
  },
  sellthroughChart: {
    color1: null,
    color2: null,
    color3: null,
    color4: null,
    color5: null
  },
  transferMap: {
    shape: { fill: null, stroke: null }
  },
  avatar: {
    color: null,
    backgroundColor: null
  },
  errorDetails: {
    container: {
      backgroundColor: null,
      borderColor: null
    },
    summary: {
      textColor: null
    },
    stack: {
      backgroundColor: null,
      textColor: null
    }
  },
  groupCard: {
    headerOverlayColor: null,
    statBorderColor: null,
    statLabelTextColor: null,
    thumbnailBorderColor: null
  }
});
